<template>
  <div class="fzxw" >
        <div class="ruanzhu" v-for="(item,i) in rzImg" :key="i" >
            <img :src="item.img" alt="" v-if="$route.query.id - 0 === i">
        </div>
  </div>
</template>

<script>
export default {
  name: 'fzxw',
   components: {
  },
  data () {
    return {
      rzImg: [
        {
          img: require('../../static/img/rb_rzs.png'),
          id: '0'
        },
        {
         img: require('../../static/img/lhb_rzs.png'),
          id: '1'
        },
        {
          img: require('../../static/img/xe_rzs.png'),
          id: '2'
        },
        {
         img: require('../../static/img/zzb_rzs.png'),
          id: '3'
        },
        {
          img: require('../../static/img/lcb_rzs.png'),
          id: '4'
        },
        {
           img: require('../../static/img/tb_rzs.png'),
          id: '5'
        },
        {
           img: require('../../static/img/dlb_rzs.png'),
          id: '6'
        },
        {
           img: require('../../static/img/xbb_rzs.png'),
          id: '7'
        },
        {
           img: require('../../static/img/fz_rzs.png'),
          id: '8'
        }
      ]
    }
  },
  methods: {
    skip (url) {
      location.href = url
    }
  }
}
</script>
<style lang="scss" scoped>
.fzxw{
  .ruanzhu{
    width: 100%;
    img{
      display: block;
      width: 100%;
      height: 100%;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/Ruanzhu.vue